(() => {
  if (window.ultiShellLoaded) return;
  window.ultiShellLoaded = true;
  const closeDetails = root => root.querySelectorAll('details[open]').forEach(d => { d.open = false; });
  const welcomeCleanups = new WeakMap();
  let welcomeHandled = false;
  function initWelcome(root) {
    root.querySelectorAll('[data-shell-welcome]').forEach(dialog => {
      if (welcomeCleanups.has(dialog) || typeof dialog.showModal !== 'function') return;
      if (/(^|\/)cart(?:\/|$)/.test(location.pathname)) return;
      const key = 'ulti_newsletter_popup_dismissed';
      const duration = Number(dialog.dataset.dismissDays) * 86400000;
      function recentlyDismissed() {
        for (const storageName of ['localStorage', 'sessionStorage']) {
          try {
            const stamp = Number(window[storageName].getItem(key));
            if (stamp > 0 && Date.now() - stamp < duration) return true;
          } catch { /* Storage may be denied in private browsing. */ }
        }
        return welcomeHandled;
      }
      function persist() {
        welcomeHandled = true;
        for (const storageName of ['localStorage', 'sessionStorage']) {
          try { window[storageName].setItem(key, String(Date.now())); } catch { /* In-memory dismissal remains active. */ }
        }
      }
      const response = dialog.querySelector('[data-newsletter-state="pending"], [data-newsletter-state="error"]');
      if (recentlyDismissed() && !response) return;
      let elapsed = Boolean(response), scrolled = Boolean(response), shown = false, restored = false;
      let returnFocus;
      const lifecycle = new AbortController();
      const options = { signal: lifecycle.signal };
      function maybeShow() {
        if (shown || !elapsed || !scrolled || (recentlyDismissed() && !response)) return;
        if (document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')) return;
        if (document.visibilityState !== 'visible') return;
        shown = true;
        welcomeHandled = true;
        returnFocus = document.activeElement;
        dialog.showModal();
        (response || dialog.querySelector('input[type="email"]') || dialog.querySelector('[data-welcome-close]')).focus();
        document.documentElement.classList.add('ulti-shell-welcome-open');
      }
      function scroll() {
        const distance = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const ratio = distance > 0 ? window.scrollY / distance : 0;
        if (ratio >= Number(dialog.dataset.scroll) / 100) scrolled = true;
        maybeShow();
      }
      const timer = setTimeout(() => { elapsed = true; scroll(); }, Number(dialog.dataset.delay) * 1000);
      window.addEventListener('scroll', scroll, { ...options, passive: true });
      document.addEventListener('close', () => setTimeout(() => { if (dialog.isConnected) maybeShow(); }, 0), { ...options, capture: true });
      document.addEventListener('visibilitychange', maybeShow, options);
      scroll();
      function restore() {
        if (restored || !shown) return;
        restored = true;
        persist();
        document.documentElement.classList.remove('ulti-shell-welcome-open');
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      }
      function close() { dialog.close(); restore(); }
      dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close, options));
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, options);
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
      }, options);
      dialog.addEventListener('close', restore, options);
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button:not([disabled]),input:not([disabled]):not([type="hidden"]),a[href]')].filter(e => !e.closest('[hidden]'));
        const first = controls[0], last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      welcomeCleanups.set(dialog, () => {
        clearTimeout(timer);
        lifecycle.abort();
        if (dialog.open) { dialog.close(); document.documentElement.classList.remove('ulti-shell-welcome-open'); }
        welcomeCleanups.delete(dialog);
      });
    });
  }
  function init(root = document) {
    initWelcome(root);
    root.querySelectorAll('.ulti-shell-newsletter-form').forEach(form => {
      if (form.dataset.shellReady) return;
      form.dataset.shellReady = 'true';
      form.addEventListener('submit', event => {
        if (document.body.dataset.localPreview === 'true' || window.Shopify?.designMode) {
          event.preventDefault();
          const error = form.querySelector('[data-newsletter-preview-error]');
          if (error) { error.textContent = 'Preview only: no subscription was sent.'; error.hidden = false; }
        }
        // Production uses the native POST and Shopify CAPTCHA without interception.
      });
    });
    root.querySelectorAll('[data-shell-header]').forEach(header => {
      if (header.dataset.shellReady) return;
      header.dataset.shellReady = 'true';
      const dialog = header.querySelector('dialog');
      const opener = header.querySelector('[data-shell-search-open]');
      let previousOverflow;
      opener.addEventListener('click', e => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || typeof dialog.showModal !== 'function') return;
        e.preventDefault();
        closeDetails(header);
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      dialog.querySelector('[data-shell-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', e => {
        if (e.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), a[href]')];
        const first = controls[0], last = controls.at(-1);
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      dialog.addEventListener('click', e => {
        const box = dialog.getBoundingClientRect();
        if (e.target === dialog && (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; opener.focus(); });
      header.addEventListener('keydown', e => {
        if (e.key !== 'Escape' || dialog.open) return;
        const open = e.target.closest('details[open]');
        if (open) { e.preventDefault(); e.stopPropagation(); open.open = false; open.querySelector('summary').focus(); }
      });
      header.querySelectorAll('.ulti-shell-nav-item').forEach(item => {
        const details = item.querySelector('details');
        if (!details) return;
        let timer;
        const open = () => {
          clearTimeout(timer);
          header.querySelectorAll('.ulti-shell-dropdown').forEach(d => { if (d !== details) d.open = false; });
          details.open = true;
        };
        item.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') open(); });
        item.addEventListener('pointerleave', () => { timer = setTimeout(() => { if (!item.contains(document.activeElement)) details.open = false; }, 200); });
        item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) details.open = false; });
        details.addEventListener('toggle', () => {
          details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
          if (details.open) header.querySelectorAll('.ulti-shell-dropdown').forEach(d => { if (d !== details) d.open = false; });
        });
      });
      header.querySelector('.ulti-shell-mobile nav').addEventListener('click', e => { if (e.target.closest('a')) closeDetails(header); });
      header.addEventListener('click', e => {
        const swatch = e.target.closest('[data-shell-swatch]');
        if (!swatch) return;
        const card = swatch.closest('.ulti-shell-card');
        const img = card.querySelector('img');
        img.src = swatch.dataset.shellSwatch;
        img.alt = swatch.dataset.alt;
        card.querySelectorAll('[data-shell-swatch]').forEach(b => b.setAttribute('aria-pressed', String(b === swatch)));
        card.querySelector('[data-shell-color]').textContent = swatch.getAttribute('aria-label');
      });
    });
    root.querySelectorAll('[data-shell-projects]').forEach(directory => {
      if (directory.dataset.shellReady) return;
      directory.dataset.shellReady = 'true';
      directory.querySelector('.ulti-shell-project-controls').hidden = false;
      const mode = directory.querySelector('[data-project-mode]');
      const year = directory.querySelector('select[data-project-year]');
      const windowSelect = directory.querySelector('select[data-project-window]');
      const projects = [...directory.querySelectorAll('article[data-project-key]')];
      const now = new Date();
      const current = now.getFullYear() * 12 + now.getMonth();
      function windows() {
        windowSelect.replaceChildren(new Option('All windows', ''));
        [...new Set(projects.filter(p => !year.value || p.dataset.projectYear === year.value).map(p => p.dataset.projectWindow))].forEach(w => windowSelect.add(new Option(w, w)));
      }
      function filter() {
        year.disabled = windowSelect.disabled = mode.value === 'nearby';
        let visible = 0;
        projects.forEach(p => {
          const key = Number(p.dataset.projectKey);
          const month = Math.floor(key / 100) * 12 + key % 100 - 1;
          const show = mode.value === 'nearby' ? Math.abs(month - current) <= 3 : (!year.value || p.dataset.projectYear === year.value) && (!windowSelect.value || p.dataset.projectWindow === windowSelect.value);
          p.hidden = !show;
          if (show) visible++;
        });
        directory.querySelector('[data-project-empty]').hidden = visible > 0;
      }
      mode.addEventListener('change', filter);
      year.addEventListener('change', () => { windows(); filter(); });
      windowSelect.addEventListener('change', filter);
      windows(); filter();
    });
    root.querySelector('[data-shell-form-feedback]')?.focus();
  }
  document.addEventListener('click', e => document.querySelectorAll('[data-shell-header]').forEach(h => { if (!h.contains(e.target)) closeDetails(h); }));
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-shell-welcome]').forEach(dialog => welcomeCleanups.get(dialog)?.());
    if (e.target.querySelector('dialog[open]')) document.body.style.overflow = '';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
